import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Check the report_logic_version for a patient to determine which report generation logic to use.
 * 
 * @param {string} patientId - The patient's ID
 * @returns {Promise<number>} The report logic version (defaults to 1 if not set)
 */
export async function checkReportLogicVersion(patientId) {
    try {
        if (!patientId) {
            console.warn('No patient ID provided to checkReportLogicVersion');
            return 1;
        }

        const patientDocRef = doc(db, 'patients', patientId);
        const patientDoc = await getDoc(patientDocRef);
        
        if (!patientDoc.exists()) {
            console.warn(`Patient document not found for patient ${patientId}`);
            return 1; // Default to version 1 (old logic)
        }
        
        const patientData = patientDoc.data();
        const reportLogicVersion = patientData.report_logic_version || 1;
        
        console.log(`Patient ${patientId} has report_logic_version: ${reportLogicVersion}`);
        return reportLogicVersion;
        
    } catch (error) {
        console.error(`Error checking report_logic_version for patient ${patientId}:`, error);
        return 1; // Default to version 1 (old logic) on error
    }
}

/**
 * Determine if the unified report generation logic should be used for this patient.
 * 
 * @param {string} patientId - The patient's ID
 * @returns {Promise<boolean>} True if unified logic should be used (version 2), False otherwise
 */
export async function shouldUseUnifiedLogic(patientId) {
    const version = await checkReportLogicVersion(patientId);
    return version === 2;
}

